import type { CandidateIndustry } from '@axiom/validation';

export const IndustriesUtil = {
  getDisplayableIndustries: (
    industries: CandidateIndustry[] | null
  ): CandidateIndustry[] => {
    return (industries || []).filter(
      i => i.industryValue.toLowerCase() !== 'other'
    );
  },
};
